export const HOME = '/'
export const ABOUT = '/about'
export const ACCOUNT = '/account'
export const ADMIN = '/admin'
export const ADMIN_DETAILS = '/admin/:id'
export const FEATURES = '/features'
export const LANDING = '/home'
export const LIFESTYLE = '/lifestyle'
export const MUSIC = '/music'
export const NEWS = '/news'
export const PUBLISH = '/publish'
export const PASSWORD_FORGET = '/pw-forget'
export const SEARCH = '/search'
export const SIGN_UP = '/signup'
export const SIGN_IN = '/signin'
export const TRENDING = '/trending'
